import { UploadLocale } from 'antd/lib/upload/interface'

export const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
}

export const myLocale: UploadLocale = {
  uploading: 'กำลังอัพ...',
  uploadError: 'อัพโหลดไฟล์ไม่สำเร็จ',
}
